import {ParamsModel} from 'src/app/modules/common/Model'
import {NabilAuctionCategoryModel, SortNabilAuctionCategoryModel} from '../Model/Model'
import {actionTypes} from './constants'
export const actions = {
  // get NabilAuctionCategory
  getAllNabilAuctionCategory: () => ({
    type: actionTypes.GET_ALL_NABIL_AUCTION_CATEGORY_START,
  }),
  getAllNabilAuctionCategorySuccess: (data: NabilAuctionCategoryModel | any) => ({
    type: actionTypes.GET_ALL_NABIL_AUCTION_CATEGORY_SUCCESS,
    payload: data,
  }),
  getAllNabilAuctionCategoryFinish: () => ({
    type: actionTypes.GET_ALL_NABIL_AUCTION_CATEGORY_FINISH,
  }),

  // get NabilAuctionCategory DATA
  getNabilAuctionCategory: (params: ParamsModel = {page: 1, limit: 10}) => ({
    type: actionTypes.GET_NABIL_AUCTION_CATEGORY_START,
    payload: params,
  }),
  getNabilAuctionCategorySuccess: (data: NabilAuctionCategoryModel | any) => ({
    type: actionTypes.GET_NABIL_AUCTION_CATEGORY_SUCCESS,
    payload: data,
  }),
  getNabilAuctionCategoryFinish: () => ({
    type: actionTypes.GET_NABIL_AUCTION_CATEGORY_FINISH,
  }),

  // create key
  addNabilAuctionCategory: (data: NabilAuctionCategoryModel | any) => ({
    type: actionTypes.ADD_NABIL_AUCTION_CATEGORY_START,
    payload: data,
  }),
  addNabilAuctionCategorySuccess: (task: any) => ({
    type: actionTypes.ADD_NABIL_AUCTION_CATEGORY_SUCCESS,
    payload: task,
  }),
  addNabilAuctionCategoryFinish: () => ({
    type: actionTypes.ADD_NABIL_AUCTION_CATEGORY_FINISH,
  }),
  resetNabilAuctionCategory: () => ({
    type: actionTypes.RESET_NABIL_AUCTION_CATEGORY,
  }),

  //Update NabilAuctionCategory
  updateNabilAuctionCategory: (data: NabilAuctionCategoryModel | any, id: string) => ({
    type: actionTypes.UPDATE_NABIL_AUCTION_CATEGORY_START,
    payload: data,
    id,
  }),

  updateNabilAuctionCategorySuccess: (data: NabilAuctionCategoryModel | any) => ({
    type: actionTypes.UPDATE_NABIL_AUCTION_CATEGORY_SUCCESS,
    payload: data,
  }),

  updateNabilAuctionCategoryFinish: () => ({
    type: actionTypes.UPDATE_NABIL_AUCTION_CATEGORY_FINISH,
  }),

  // delete key
  deleteNabilAuctionCategory: (data: string[]) => ({
    type: actionTypes.DELETE_NABIL_AUCTION_CATEGORY_START,
    payload: {ids: data},
  }),
  deleteNabilAuctionCategorySuccess: (data: any) => ({
    type: actionTypes.DELETE_NABIL_AUCTION_CATEGORY_SUCCESS,
    payload: data,
  }),
  deleteNabilAuctionCategoryFinish: () => ({
    type: actionTypes.DELETE_NABIL_AUCTION_CATEGORY_FINISH,
  }),

  //Enable NabilAuctionCategory
  enableNabilAuctionCategory: (data: any) => ({
    type: actionTypes.ENABLE_NABIL_AUCTION_CATEGORY_REQUEST,
    payload: {data},
  }),

  enableNabilAuctionCategorySuccess: (task: any) => ({
    type: actionTypes.ENABLE_NABIL_AUCTION_CATEGORY_SUCCESS,
    payload: task,
  }),
  enableNabilAuctionCategoryFinish: () => ({
    type: actionTypes.ENABLE_NABIL_AUCTION_CATEGORY_FINISH,
  }),

  //Disable NabilAuctionCategory
  disableNabilAuctionCategory: (data: any) => ({
    type: actionTypes.DISABLE_NABIL_AUCTION_CATEGORY_REQUEST,
    payload: {data},
  }),

  disableNabilAuctionCategorySuccess: (task: any) => ({
    type: actionTypes.DISABLE_NABIL_AUCTION_CATEGORY_SUCCESS,
    payload: task,
  }),
  disableNabilAuctionCategoryFinish: () => ({
    type: actionTypes.DISABLE_NABIL_AUCTION_CATEGORY_FINISH,
  }),

  //Enable NabilAuctionCategory
  singleEnableNabilAuctionCategory: (data: any) => ({
    type: actionTypes.SINGLE_ENABLE_NABIL_AUCTION_CATEGORY_REQUEST,
    payload: {data},
  }),

  singleEnableNabilAuctionCategorySuccess: (task: any) => ({
    type: actionTypes.SINGLE_ENABLE_NABIL_AUCTION_CATEGORY_SUCCESS,
    payload: task,
  }),
  singleEnableNabilAuctionCategoryFinish: () => ({
    type: actionTypes.SINGLE_ENABLE_NABIL_AUCTION_CATEGORY_FINISH,
  }),

  //Disable NabilAuctionCategory
  singleDisableNabilAuctionCategory: (data: any) => ({
    type: actionTypes.SINGLE_DISABLE_NABIL_AUCTION_CATEGORY_REQUEST,
    payload: {data},
  }),

  singleDisableNabilAuctionCategorySuccess: (task: any) => ({
    type: actionTypes.SINGLE_DISABLE_NABIL_AUCTION_CATEGORY_SUCCESS,
    payload: task,
  }),
  singleDisableNabilAuctionCategoryFinish: () => ({
    type: actionTypes.SINGLE_DISABLE_NABIL_AUCTION_CATEGORY_FINISH,
  }),

  // sort
  sortNabilAuctionCategory: (data: SortNabilAuctionCategoryModel) => ({
    type: actionTypes.SORT_NABIL_AUCTION_CATEGORY_START,
    payload: data,
  }),
  sortNabilAuctionCategorySuccess: (data: Array<NabilAuctionCategoryModel>) => ({
    type: actionTypes.SORT_NABIL_AUCTION_CATEGORY_SUCCESS,
    payload: data,
  }),
  sortNabilAuctionCategoryFinish: () => ({
    type: actionTypes.SORT_NABIL_AUCTION_CATEGORY_FINISH,
  }),
  sortNabilAuctionCategoryReset: () => ({
    type: actionTypes.SORT_NABIL_AUCTION_CATEGORY_RESET,
  }),
}
